import React from 'react'
import {BiArrowBack} from 'react-icons/bi'



/**
 * A back button component.
 *  #core
 * @param {object} props - Props passed to the component.
 * @param {number} props.size - The size of the button icon. Defaults to 15.
 * @param {function} props.onClick - The function to call when the button is clicked.
 * @returns {React.ReactElement} A React element representing the back button.
 */
const BackButton = ({ size=15, onClick}) => {
  return (
    <div>

        <button onClick={onClick} className='round-back-button'>
            <BiArrowBack
            size={size}
            color={"white"}
            />
        </button>

</div>
  )
}

export default BackButton
